import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-huongdansudung',
  templateUrl: './huongdansudung.component.html',
  styleUrls: ['./huongdansudung.component.scss']
})
export class HuongDanSuDungComponent implements OnInit {
  @Input() currentUrl: string = "";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/share/huong-dan-su-dung/huongdansudung.component.ts